import { useRef, useState } from "react";
import { FileText, Upload, X } from "lucide-react";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { api, resolveImage, errorText } from "@/lib/api";
import { Field, inputClass, GhostButton } from "./fields";

export default function BrochureField({ value, onChange, testId = "yacht-form-brochure" }) {
  const fileRef = useRef(null);
  const [uploading, setUploading] = useState(false);

  const upload = async (file) => {
    if (!file) return;
    setUploading(true);
    const body = new FormData();
    body.append("file", file);
    try {
      const { data } = await api.post("/admin/upload", body, { headers: { "Content-Type": "multipart/form-data" } });
      onChange(data.url);
      toast.success("Brochure uploaded.");
    } catch (err) {
      toast.error(errorText(err, "Upload failed."));
    } finally {
      setUploading(false);
      if (fileRef.current) fileRef.current.value = "";
    }
  };

  return (
    <Field label="Brochure PDF" hint="Leave empty to auto-generate a brochure from the specs above. Paste a PDF link or upload one (max 25 MB).">
      <div className="flex gap-3">
        <Input value={value} onChange={(e) => onChange(e.target.value)} placeholder="https://… .pdf" data-testid={`${testId}-url`} className={inputClass} />
        <GhostButton type="button" onClick={() => fileRef.current?.click()} disabled={uploading} data-testid={`${testId}-upload`} className="shrink-0 inline-flex items-center gap-2">
          <Upload size={12} /> {uploading ? "Uploading…" : "Upload PDF"}
        </GhostButton>
        <input ref={fileRef} type="file" accept="application/pdf" className="hidden" onChange={(e) => upload(e.target.files?.[0])} data-testid={`${testId}-file`} />
      </div>
      {value && (
        <div className="mt-3 inline-flex items-center gap-3 border border-navy-ink/10 bg-white px-3 py-2 text-xs text-navy-ink" data-testid={`${testId}-current`}>
          <FileText size={14} className="text-gold" />
          <a href={resolveImage(value)} target="_blank" rel="noreferrer" className="max-w-xs truncate hover:text-gold">{value}</a>
          <button type="button" onClick={() => onChange("")} className="text-mist hover:text-red-700" aria-label="Clear" data-testid={`${testId}-clear`}><X size={12} /></button>
        </div>
      )}
    </Field>
  );
}
